/**
 * Created by Ning Jiang on 2/7/2018.
 */

import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {IWinRatioConfig, WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {Timeline, TimelineLite, TweenLite} from "gsap";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {MonkeysGoldGameConfig} from "../../MonkeysGoldGameConfig";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {MonkeysGoldBigWinCoinsRain} from "./MonkeysGoldBigWinCoinsRain";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {INolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {MonkeysGoldSoundConfig} from "../../MonkeysGoldSoundConfig";

export class MonkeysGoldBigWinView extends BaseView {

    private _placeHolderText:PIXI.Text;
    private _isShowing:boolean = false;
    private _dimmer:PIXI.Graphics;
    private _layer:ScalableLayer;
    private _bigWinAnimation:PIXI.spine.Spine;
    private _bigWinMonkey:PIXI.spine.Spine;
    private _moneyPile:PIXI.Sprite;
    private _coinsRain:MonkeysGoldBigWinCoinsRain;
    private _coinsRainContainer:PIXI.Container;
    private _coinsRainContainerContainer:PIXI.Container;
    private _currentLevel:string = "";
    private _monkeyCoinContainer:PIXI.Container;
    private _coinExplosion:TimelineSprite;
    private _newLevelTL:TimelineLite;
    private _monkeyHideTL:TimelineLite;

    private static MONKEY_COIN_CONTAINER_DEFAULT_Y_POS:number = 720;
    private static MONKEY_DEFAULT_Y_POS:number = -76;
    private static MONEY_PILE_DEFAULT_Y_POS:number = -180;

    constructor() {
        super();
        this._coinsRainContainer = new PIXI.Container();
        this._coinsRain = new MonkeysGoldBigWinCoinsRain(this._coinsRainContainer);
        this._layer = StageManager.getLayer(MonkeysGoldGameConfig.instance.LAYERS.BIG_WIN.name);
    }

    protected initAnimations():void {
        this._layer.addChild(this);

        this._dimmer = new PIXI.Graphics();
        this._dimmer.alpha = 0;
        this.addChild(this._dimmer);

        this._bigWinAnimation = new PIXI.spine.Spine(GameResources.getSpineAsset("spineBigWin"));
        this._bigWinAnimation.position.x = 720 / 2;
        this._bigWinAnimation.position.y = 720 / 2 - 20;
        this._bigWinAnimation.scale.set(0.8, 0.8);
        this._bigWinAnimation.visible = false;
        this.addChild(this._bigWinAnimation);

        this._coinsRainContainerContainer = new PIXI.Container();
        this.addChild(this._coinsRainContainerContainer);
        this._coinsRainContainerContainer.addChild(this._coinsRainContainer);

        this._monkeyCoinContainer = new PIXI.Container();
        this._monkeyCoinContainer.position.x = 720 / 2;
        this._monkeyCoinContainer.position.y = MonkeysGoldBigWinView.MONKEY_COIN_CONTAINER_DEFAULT_Y_POS;
        this._monkeyCoinContainer.visible = false;
        this.addChild(this._monkeyCoinContainer);

        this._bigWinMonkey = new PIXI.spine.Spine(GameResources.getSpineAsset("spineBigWinMonkey"));
        this._bigWinMonkey.position.y = 20 + this._bigWinMonkey.height / 2;//MonkeysGoldBigWinView.MONKEY_DEFAULT_Y_POS;
        this._monkeyCoinContainer.addChild(this._bigWinMonkey);

        this._coinExplosion = new TimelineSprite(GameResources.getTextures("coinExplosion"));
        this._coinExplosion.position.x -= this._coinExplosion.width / 2;
        this._coinExplosion.position.y = -276;
        this._monkeyCoinContainer.addChild(this._coinExplosion);

        this._moneyPile = new PIXI.Sprite(GameResources.getTextures("moneyPile")[0]);
        this._moneyPile.position.x -= this._moneyPile.width / 2;
        this._moneyPile.position.y = MonkeysGoldBigWinView.MONEY_PILE_DEFAULT_Y_POS;
        this._monkeyCoinContainer.addChild(this._moneyPile);

        this._placeHolderText = new PIXI.Text("", {"fontSize" : 180, "fill" : "#ffffff"});
        this._placeHolderText.alpha = 0;
    }

    protected onResize(resizeData:IResizeData):void {
        const screenWidth:number = resizeData.width;
        const screenHeight:number = resizeData.height;
        const leftOffset:number = 0 - ((resizeData.width - 720) / 2);
        const topOffset:number = 0 - ((resizeData.height - 720) / 2);

        this._dimmer.clear();
        this._dimmer.beginFill(0x000000, 0.8);
        this._dimmer.drawRect(leftOffset, topOffset, screenWidth, screenHeight);

        const bottomSpace:number = (resizeData.height - 720) / 2;
        if(bottomSpace > 250) {
            this._monkeyCoinContainer.position.y = (720 + bottomSpace) - 150;
        } else {
            this._monkeyCoinContainer.position.y = MonkeysGoldBigWinView.MONKEY_COIN_CONTAINER_DEFAULT_Y_POS;
        }
    }

    public triggerMonkeyHideTL(delay:number):void {
        if(this._monkeyHideTL && this._monkeyHideTL.isActive()) {
            this._monkeyHideTL.pause();
            this._monkeyHideTL.kill();
        }
        this._monkeyHideTL = new TimelineLite();
        this._monkeyHideTL.add(
            new TweenLite(this._bigWinMonkey.position, 0.3, {
                y : 80 + this._bigWinMonkey.height / 2
            }), "+=" + (delay - 0.5)
        );
    }

    public getBigWinLevelAnimation(winRatioConfig:IWinRatioConfig):Timeline {
        const timeline:TimelineLite = new TimelineLite();
        timeline.add([
            () => {
                this.updateBigWinLevelAnimation(winRatioConfig.type!);
            },
            TweenLite.to(this._dimmer, 0.1, {alpha : 1}),
            TweenLite.to(this._placeHolderText, 0.2, {alpha : 0}),
            TweenLite.to(this._placeHolderText.scale, winRatioConfig.duration, {x : 1})
        ]);

        return timeline;
    }

    private updateBigWinLevelAnimation(winType:WinRatioType, playSound:boolean = true):TimelineLite {
        this._isShowing = true;
        this._currentLevel = winType;
        if(this._newLevelTL && this._newLevelTL.isActive()) {
            this._newLevelTL.pause();
            this._newLevelTL.kill();
        }
        this._newLevelTL = new TimelineLite();
        switch(winType) {
            case WinRatioType.SUPER_MEGA_WIN :
                this._newLevelTL.add(() => (<INolimitAudioPlayer>SlotGame.sound).playTrack({
                    name : MonkeysGoldSoundConfig.instance.BIG_WIN_LEVEL_3
                }));
                this._newLevelTL.add(() => (<INolimitAudioPlayer>SlotGame.sound).stopTrack(MonkeysGoldSoundConfig.instance.BIG_WIN_LEVEL_2));
                this._newLevelTL.add(() => this._bigWinMonkey.position.y = 20 + this._bigWinMonkey.height / 2);
                this._newLevelTL.add(() => this._bigWinAnimation.skeleton.setSkin(null));
                this._newLevelTL.add(() => this._bigWinAnimation.skeleton.setSkinByName("super_mega_win2"));
                this._newLevelTL.add(() => this._bigWinAnimation.skeleton.setSlotsToSetupPose());
                this._newLevelTL.add(() => this._bigWinAnimation.state.setAnimation(0, "Wins_animation", false));
                this._newLevelTL.add(() => this._bigWinMonkey.skeleton.setSlotsToSetupPose());
                this._newLevelTL.add(() => this._bigWinMonkey.state.setAnimation(0, "animation3", true).timeScale = 1.4);
                this._newLevelTL.add(() => this._coinsRain.setParticleAmount(3));
                this._newLevelTL.add([
                    new TweenLite(this._bigWinMonkey.position, 0.3, {
                        y : MonkeysGoldBigWinView.MONKEY_DEFAULT_Y_POS
                    }),
                    new TimelineLite().add(this._coinExplosion.getAnimation())
                ]);
                return this._newLevelTL;
            case WinRatioType.MEGA_WIN :
                this._newLevelTL.add(() => (<INolimitAudioPlayer>SlotGame.sound).playTrack({
                    name : MonkeysGoldSoundConfig.instance.BIG_WIN_LEVEL_2
                }));
                this._newLevelTL.add(() => (<INolimitAudioPlayer>SlotGame.sound).stopTrack(MonkeysGoldSoundConfig.instance.BIG_WIN_LEVEL_1));
                this._newLevelTL.add(() => this._bigWinMonkey.position.y = 20 + this._bigWinMonkey.height / 2);
                this._newLevelTL.add(() => this._bigWinAnimation.skeleton.setSkin(null));
                this._newLevelTL.add(() => this._bigWinAnimation.skeleton.setSkinByName("mega_win"));
                this._newLevelTL.add(() => this._bigWinAnimation.skeleton.setSlotsToSetupPose());
                this._newLevelTL.add(() => this._bigWinAnimation.state.setAnimation(0, "Wins_animation", false));
                this._newLevelTL.add(() => this._bigWinMonkey.skeleton.setSlotsToSetupPose());
                this._newLevelTL.add(() => this._bigWinMonkey.state.setAnimation(0, "animation2", true).timeScale = 1.37);
                this._newLevelTL.add(() => this._coinsRain.setParticleAmount(2));
                this._newLevelTL.add([
                    new TweenLite(this._bigWinMonkey.position, 0.3, {
                        y : MonkeysGoldBigWinView.MONKEY_DEFAULT_Y_POS
                    }),
                    new TimelineLite().add(this._coinExplosion.getAnimation())
                ]);
                return this._newLevelTL;
            case WinRatioType.BIG_WIN :
                this._newLevelTL.add(() => (<INolimitAudioPlayer>SlotGame.sound).playTrack({
                    name : MonkeysGoldSoundConfig.instance.BIG_WIN_LEVEL_1
                }));
                this._newLevelTL.add(() => this._bigWinMonkey.position.y = 20 + this._bigWinMonkey.height / 2);
                this._newLevelTL.add(() => this._bigWinAnimation.updateTransform());
                this._newLevelTL.add(() => this._bigWinAnimation.visible = true);
                this._newLevelTL.add(() => this._moneyPile.position.y = 0);
                this._newLevelTL.add(() => this._monkeyCoinContainer.visible = true);
                this._newLevelTL.add(() => this._coinsRainContainerContainer.addChild(this._coinsRainContainer));
                this._newLevelTL.add(() => this._coinsRainContainer.visible = true);
                this._newLevelTL.add(() => this._bigWinAnimation.skeleton.setSkin(null));
                this._newLevelTL.add(() => this._bigWinAnimation.skeleton.setSkinByName("big_win"));
                this._newLevelTL.add(() => this._bigWinAnimation.skeleton.setSlotsToSetupPose());
                this._newLevelTL.add(() => this._bigWinAnimation.state.setAnimation(0, "Wins_animation", false));
                this._newLevelTL.add(() => this._bigWinMonkey.skeleton.setSlotsToSetupPose());
                this._newLevelTL.add(() => this._bigWinMonkey.state.setAnimation(0, "animation", true).timeScale = 1.37);
                this._newLevelTL.add(
                    new TweenLite(this._moneyPile.position, 0.3, {
                        y : MonkeysGoldBigWinView.MONEY_PILE_DEFAULT_Y_POS
                    }));
                this._newLevelTL.add(() => this._coinsRain.setParticleAmount(1));
                this._newLevelTL.add(() => this._coinsRain.startRain(0));
                this._newLevelTL.add([
                    new TweenLite(this._bigWinMonkey.position, 0.3, {
                        y : MonkeysGoldBigWinView.MONKEY_DEFAULT_Y_POS
                    }),
                    this._coinExplosion.getAnimation()
                ]);

                return this._newLevelTL;
            default :
                return this._newLevelTL;
        }
    }

    public playEndingAnimation(endWinRatioConfig:IWinRatioConfig):void {
        if(this._newLevelTL && this._newLevelTL.isActive()) {
            this._newLevelTL.pause();
            this._newLevelTL.kill();
        }
        const timeline:TimelineLite = new TimelineLite();
        timeline.add(() => this._coinsRain.stopRain());
        if(endWinRatioConfig.type! !== this._currentLevel) {
            timeline.add(() => this.updateBigWinLevelAnimation(endWinRatioConfig.type!));
        }
        timeline.add(() => {
            (<INolimitAudioPlayer>SlotGame.sound).stopTrack(MonkeysGoldSoundConfig.instance.BIG_WIN_LEVEL_1);
            (<INolimitAudioPlayer>SlotGame.sound).stopTrack(MonkeysGoldSoundConfig.instance.BIG_WIN_LEVEL_2);
            (<INolimitAudioPlayer>SlotGame.sound).stopTrack(MonkeysGoldSoundConfig.instance.BIG_WIN_LEVEL_3);
            (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : MonkeysGoldSoundConfig.instance.BIG_WIN_ENDS});
        });
        timeline.add([
            TweenLite.to(this._dimmer, 0.1, {alpha : 0, delay : 0.5}),
        ]);
        timeline.add(() => this._currentLevel = "");
        timeline.add(() => this._isShowing = false);
        timeline.add(() => this._bigWinAnimation.visible = false);
        timeline.add(() => this._bigWinAnimation.state.clearTrack(0));
        timeline.add(() => this._monkeyCoinContainer.visible = false);
        timeline.add(() => this._bigWinMonkey.state.clearTrack(0));
        timeline.add(this._coinExplosion.getAnimation());
    }

    get coinsRain():MonkeysGoldBigWinCoinsRain {
        return this._coinsRain;
    }

    get coinsRainContainer():PIXI.Container {
        return this._coinsRainContainer;
    }
}